import React from 'react';

import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import SETTINGS from "../../../settings.js";

import testGeojson from '../../../utils/testGeojson.js'
import getGeojsonBoundingBox from "../../../utils/maps/geojsonBoundingBox";



mapboxgl.accessToken = SETTINGS.mapboxToken;


export default class MapFrame extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lng: 5,
            lat: 34,
            zoom: 2,

        };
    }

    static defaultProps = {
        geojsonData: {},
        polygonFill: '#A0DF00'
    }

    componentDidMount() {

        let {geojsonData, polygonFill} = this.props

        const map = new mapboxgl.Map({
            container: this.mapContainer,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [this.state.lng, this.state.lat],
            zoom: this.state.zoom
        });

        map.on('move', () => {
            this.setState({
                lng: map.getCenter().lng.toFixed(4),
                lat: map.getCenter().lat.toFixed(4),
                zoom: map.getZoom().toFixed(2)
            });
        });


        map.on('load', function () {
            map.addSource('primary', {
                'type': 'geojson',
                'data':  geojsonData
            });

            let boundingBox = getGeojsonBoundingBox(geojsonData);

            map.fitBounds([[boundingBox.xMin, boundingBox.yMin], [boundingBox.xMax, boundingBox.yMax]]);


            map.addLayer({
                'id': 'primary',
                'type': 'fill',
                'source': 'primary',
                'layout': {},
                'paint': {
                    'fill-color': polygonFill,
                    'fill-opacity': 0.8,
                    'fill-outline-color': 'red',
                }
            });


            map.on('click', 'primary', function (e) {
                let coordinates = [e.lngLat.lng, e.lngLat.lat];
                let name = e.features[0].properties.name;

                //     // Ensure that if the map is zoomed out such that multiple
                //     // copies of the feature are visible, the popup appears
                //     // over the copy being pointed to.
                // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                // }

                new mapboxgl.Popup()
                    .setLngLat(coordinates)
                    .setHTML(name)
                    .addTo(map);
            });

            // Change the cursor to a pointer when the mouse is over the places layer.
            map.on('mouseenter', 'primary', function () {
                map.getCanvas().style.cursor = 'pointer';
            });

            // Change it back to a pointer when it leaves.
            map.on('mouseleave', 'primary', function () {
                map.getCanvas().style.cursor = '';
            });

        });

        this.props.onLoadCall && this.props.onLoadCall(map);
    }


    render() {
        return (
            <div className={'map-wrapper'}>
                <div ref={el => this.mapContainer = el} className='map-container'/>
            </div>

        )
    }

}
